<template>
  <div class="animated fadeIn">
    <b-modal  ref="modal-new-followup" scrollable centered button-size="sm" v-on:hide="hideModal" v-on:close="aborted">
      <template #modal-title>
        <i class="fas fa-comments"></i>&nbsp; FOLLOW UP
      </template>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtGroup"><small class="text-danger">*</small> Tipo de Evento:</label>
          <div class="input-group">
            <b-form-select v-model="form.eventoId.value" :options="form.eventoId.options" class="mb-3" @change="onChangeEvent">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtData"><small class="text-danger">*</small> Data:</label>
          <div class="input-group">
            <b-form-input type="date"
                          id="txtData"
                          name="txtData"
                          style="height: 35px;"
                          v-model="form.data.value"
                          :required="showFieldHorario"
                          :state="form.data.state"
                          @change="onCheckDate"/>
          </div>
        </div>

        <!-- <div v-if="showFieldsDespesas && showFieldHorario" class="col-md-8" style="align-self: end;">
          <button type="button" class="btn rounded btn-third w-100" @click="onShowDespesasModal" v-b-tooltip.hover title="Adicionar despesas"><i class="fas fa-plus"></i>&nbsp; Adicionar despesas</button>
        </div> -->

        <div class="col-md-6" v-if="showFieldHorario">
          <label for="txtHorario">Horário:</label>
            <FormulateInput
                type="time"
                name="horario"
                input-class="form-control"
                :value="form.horario.value"
                v-on:blur="updateHorario"
            />
        </div>

        <div class="col-md-12 mt-3" v-if="showFieldHorario">
          <label for="txtGroup"><small v-if="form.boardColumnId.required" class="text-danger">*</small> Mover para:</label>
          <div class="input-group">
            <b-form-select v-model="form.boardColumnId.value" :options="form.boardColumnId.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>

      </div>

      <div class="form-group row mt-3" v-if="showFieldsDeslocamento">
        <div class="col-md-6">
          <label for="txtName"><small class="text-danger">*</small> Km Inicial:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-road"></i></span>
            <b-form-input type="number"
                          min="0"
                          :placeholder="'Digite o Km Inicial'"
                          v-model="form.kmInicial.value"
                          :size="form.kmInicial.maxlength"
                          :required="form.kmInicial.required"
                          :state="form.kmInicial.state"
                          @blur="onCheckKm"></b-form-input>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtName"><small class="text-danger">*</small> Km Final:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-road"></i></span>
            <b-form-input type="number"
                          min="0"
                          :placeholder="'Digite o Km Final'"
                          v-model="form.kmFinal.value"
                          :size="form.kmFinal.maxlength"
                          :required="form.kmFinal.required"
                          :state="form.kmFinal.state"
                          @blur="onCheckKm"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row mt-3">
        <div class="col-md-12">
          <label for="txtDetalhes" class="w-100">
            <small class="text-danger">*</small> Detalhes:
          </label>
          <div class="textarea-container">
            <textarea
              @dblclick="expandTextArea"
              v-b-tooltip.click
              title="Clique duplo para expandir/minimizar"
              id="txtDetalhes"
              ref="txtDetalhes"
              name="txtDetalhes"
              v-model="form.detalhes.value"
              :placeholder="'Digite os detalhes do follow-up aqui'"
              :rows="form.detalhes.rows"
              :max-rows="form.detalhes.maxRows"
              :noResize="form.detalhes.noResize"
              @input="handleInput"
              class="custom-textarea"
            ></textarea>
            <div v-if=" showSuggestions && filteredUsers.length > 0" class="suggestions-dropdown">
              <ul>
                <li
                  v-for="user in filteredUsers"
                  :key="user.id"
                  @click="selectUser(user)"
                  class="suggestion-item"
                >
                <strong>Nome: </strong> {{user.nome}} ({{ user.username }})
                <br/>
                <strong>Email:</strong>{{ user.emailCorporativo}}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group row pt-2" v-if="showFieldsDespesas">
        <div v-if="data.despesas && data.despesas.length > 0" class="col-md pt-2 pb-2">
          <b-link @click="onShowDespesasModal">{{data.despesas && data.despesas.length}} Despesas Criadas. Total: {{valorTotalDespesas.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' })}}</b-link>
          <!-- <p></p> -->
        </div>

        <div class="col-md-12">
          <button type="button" class="btn rounded btn-third w-100" @click="onShowDespesasModal" v-b-tooltip.hover title="Adicionar despesas"><i class="fas fa-plus"></i>&nbsp; Adicionar despesas</button>&nbsp;
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-12 pt-2">
          <label for="txtData"> Anexo:</label>
          <div class="input-group" @drop="onUploadDrop" @dragover="onUploadDragover">
            <div class="upload" style="cursor: pointer;" @click="onUploadClick">
              <input
                  multiple
                  type="file"
                  ref="inputFile"
                  v-show="false"
                  @change="onFileChange"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                          application/excel,
                          text/csv,
                          application/msword,
                          application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                          application/pdf,
                          image/*,
                          application/zip,
                          text/plain"
                />
              <div><i class="fas fa-file-import" style="font-size: 17px"></i></div>
              <span v-if="!attach">Clique ou arraste aqui para anexar!</span>
              <span v-else>
                <span v-for="(upload, index) in attach" :key="index">{{ upload.name }} &nbsp;</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn rounded btn-default btn-sm text-secundary" v-on:click="onClear" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonClear"><i class="fa fa-minus-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Clear}}</span></button>&nbsp;
          <button v-if="eventManager"  :disabled="disabledSendFollowUp" @click="storeSubmit" type="button" class="btn btn-third btn-sm"  v-b-tooltip.hover :title="eventManager.hasNext ? 'Próximo' : 'Salvar'"> <i :class="eventManager.hasNext ? 'far fa-arrow-alt-circle-right' : 'fas fa-check-circle'"></i><span class="d-md-down-none">&nbsp; {{ eventManager.hasNext ? 'Próximo' : 'Salvar' }}</span></button>
          <button v-else type="button" :disabled="disabledSendFollowUp" class="btn rounded btn-third btn-sm" v-on:click="onSave" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"> <i class="fa fa-check-circle"></i> <span class="d-md-down-none">{{$lang.Common.Buttons.Save}}</span></button>&nbsp;
        </div>
      </template>
    <DespesasModal ref="DespesasModal" @onBackDespesas="updateDespesasList" @onBackDespesasFiles="updateDespesasFiles"/>
    </b-modal>
  </div>
</template>
<script>
import ModalNewFollowUp from './followup.js'
export default ModalNewFollowUp
</script>

<style>
.btn-timepicker {
  display: flex;
  align-items: center;
  padding: 0px 10px;
  border-radius: 6px;
  background-color: #fff;
  color: #131313;
  border-right-color: rgba(0, 0, 0, 0.15);
  border-top-color: rgba(0, 0, 0, 0.15);
  border-bottom-color: rgba(0, 0, 0, 0.15);
}

.timepicker-input-group {
  display: flex;
  width: 100%;
}

.btn-timepicker-input {
  flex-grow: 1;
}

.btn-timepicker-input,
.btn-timepicker-input:hover{
  border-right-color: transparent !important;
}
</style>
<style scoped>
.upload {
  border: solid 1px #ccc;
  border-radius: 4px;
  background-color: #efefef;
  padding: 3%;
  width: 100%;
  text-align: center;
}
.textarea-container {
  position: relative;
  width: 100%;
}
.suggestions-dropdown {
  position: relative;
  margin: 0 auto;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 100px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 0 30px 30px 0;
  z-index: 10;
  overflow: scroll;
}

.suggestion-item {
  padding: 8px;
  cursor: pointer;
}

.suggestion-item:hover {
  background-color: #f0f0f0;
}
.custom-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
  font-size: 14px;
  resize: none;
  min-height: 120px;
  transition: border-color 0.3s;
}

.custom-textarea:focus {
  border-color: #3b82f6;
  outline: none;
  box-shadow: 0 0 5px rgba(59, 130, 246, 0.5);
}

.custom-link {
  color: blue;
  text-decoration: none;
}

.custom-link:hover {
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/followup/followup.vue